<ul [attr.aria-labelledby]="labelledby" class="segmented-button-group" role="radiogroup">
  @for (tag of selectableTags; track tag) {
    <li>
      <app-segment-button (buttonClick)="check(tag)"
        [isChecked]="isChecked(tag)"
        [name]="tag.name"
        [value]="tag.key">
      </app-segment-button>
    </li>
  }
</ul>
<ng-select (change)="check($event)"
  [clearable]="false"
  [items]="selectableTags"
  [ngModel]="value"
  [searchable]="false"
  appAddIconChevronDown
  bindLabel="name"
  bindValue="key"
  class="segmented-button-dropdown">
</ng-select>
